<template>
  <v-dialog
      v-model="activate"
      max-width="900px"
      persistent
  >
    <v-card class="px-4" color="background">
      <v-card-title>
        <vuse-section-definition
            :title="formTitle"
            icon="mdi-office-building"
            class="ml-n4 pa-0 pb-4"/>
      </v-card-title>
      <v-card-text>
        <v-container class="mb-2 pa-0">
          <v-form ref="officesForm">
            <v-sheet class="neu-glow px-6">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                      v-model="editedItem.callcenterOfficeId"
                      @input="validate"
                      :label="$t('Global.Offices.officeId')+'*'"
                      :rules="[ requiredRule ]"
                      counter="100"
                      required
                      clearable
                      :disabled="isUpdate"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                      v-model="editedItem.callcenterOfficeName"
                      @input="validate"
                      :label="$t('Global.Offices.name')+'*'"
                      :rules="[ requiredRule ]"
                      counter="200"
                      required
                      clearable
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-sheet>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeDialog">{{ $t('Global.Offices.cancel') }}</v-btn>
        <v-btn color="blue darken-1" text @click="submitItem" :disabled="!validForm">{{
            $t('Global.Offices.save')
          }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Utils from "@/mixins/Utils";

export default {
  name: "OfficeDialog",
  mixins: [Utils],
  props: {
    activate: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      editedItem: {
        officeId: null,
        companyId: this.loadCompanyId(),
        callcenterOfficeName: "",
        callcenterOfficeId: "",
      },
      defaultItem: {
        officeId: null,
        companyId: this.loadCompanyId(),
        callcenterOfficeName: "",
        callcenterOfficeId: "",
      },
      requiredRule: v => !!v || this.$t('Global.FormRules.requiredField'),
      validForm: false

    }
  },
  computed: {
    formTitle() {
      return !this.item ? this.$t('Global.Offices.newOffice') : this.$t('Global.Offices.editOffice');
    },
    isUpdate(){
      return !!this.item?.officeId
    }
  },
  methods: {
    validate() {
      this.validForm = this.$refs.officesForm.validate()
    },
    closeDialog() {
      this.editedItem = Object.assign({}, this.defaultItem)
      this.$emit('close-dialog')
    },
    submitItem() {
      for (const prop in this.editedItem) {
        if (this.editedItem[prop] === "") this.editedItem[prop] = null
      }

      this.editedItem['companyId'] = this.loadCompanyId()

      if (this.item) {
        this.$emit('update-item', this.editedItem)
      }else {
        this.editedItem['officeId'] = null
        this.$emit('create-item', this.editedItem)
      }
      this.closeDialog()
    }
  },
  mounted() {
    if (this.item) {
      this.editedItem = Object.assign({}, this.item)
    } else
      this.editedItem = Object.assign({}, this.defaultItem)
  }
}
</script>

